export interface User {
  nickname: string;
  mid: number;
  developerId: number;
  developerName: string;
  developerType: number;
  avatar?: string;
}

/**  应用某个版本的小部件状态 */
export enum AppWidgetStatus {
  /** 无小部件 */
  None = 0,
  /** 有小部件但无更新 */
  Unchanged,
  /** 有小部件且有更新待上传 */
  Updated,
}
// 解析app包的状态
export enum ParseAppStatus {
  Fail = 0, // 0解析失败
  Success, //1解析成功
  Inprocess, //2解析中
}
export interface AppInfo {
  pkgName: string;
  icon: string;
  appName: string;
  appId: number;
  category: string;
  parentCategory: string;
  downloadUrl: string;
  status: number;
  currVer: currVerData;
  // histVerList: string[],
  widgetStatus: AppWidgetStatus;
  previousWidgetStatus: AppWidgetStatus;
  appVersionCode: number;
  appVersionName: string;
  abilityCode: string;
  abilityVersion: number;
  updateTime: string;
}

export interface WidgetInfo {
  id: number;
  regionList?: string[];
  name: string;
  desc?: string; // 小部件说明
  size: string;
  widgetId: string;
  status: number;
  updateStatus: number;
  dragging?: boolean;
  lightModeUrl: string;
  darkModeUrl: string;
  multiLangList: multiLangList[];
  appVers: appVers[];
  new: boolean;
  abilityCode?: string;
  abilityVersion?: number;
  statusDesc?: {
    reason?: string;
    amendments?: string;
  };
  widgetImplInfo?: WidgetImplInfoProps;
  updateImplInfo?: WidgetImplInfoProps;
  rejects: Rejects[];
}

export interface WidgetDetile {
  id: number;
  wdId: string;
  appName: string;
  parentCategory?: string;
  category?: string;
  appPkgName: string;
  appVerCode: number;
  downloadUrl: string;
  verCode: number;
  name: string;
  providerName: string;
  lightModeUrl: string;
  darkModeUrl: string;
  regions: string[];
  createTime: number;
  updateTime: number;
  operator: string;
  status: number;
  style: number;
  multiLangList: multiLangList[];
  sys_time: number;
}

export interface WidgetData {
  widgetList: WidgetInfo[];
}

export interface CountryList {
  itemResultList: itemResultList[];
}

export interface EnumList {
  LangLocale: {
    [key: string]: string;
  };
  DesignerState: {
    [key: string]: string;
  };
}

export interface itemResultList {
  code: string;
  name: string;
  cnName: string;
}

export interface languageList {
  key: string;
  value: string;
}

export interface Rejects {
  state: number;
  reason: string;
  fileUrl: string;
  dateTime: number;
  remark: string;
}

export interface multiLangList {
  langCode: string;
  widgetLangItem: {
    dispAppName: string;
    widgetName: string;
    widgetDesc: string;
    lightModeUrl?: string;
    darkModeUrl?: string;
  };
}

export interface multiLangParse {
  [key: string]: lanParseList;
}

export interface lanParseList {
  lan: string,
  title: string,
  desc: string,
  author: string
}

export interface appVers {
  verName: string;
  verCode: number;
}

export interface currVerData {
  verCode: number;
  verName: string;
}

export interface Pagination<T> {
  currPage: number;
  pageSize: number;
  total: number;
  appList: T[];
}

export interface PaginationReq {
  pageNo: number;
  pageSize: number;
}

export interface AppInfoListReq {
  page: number;
  keyword: string;
  updateType: number;
  pageSize: number;
}
export interface WidgetImplInfoProps {
  modeList: {
    language: string;
    desc: string;
    lightMode: {
      previewUrl: string;
      url: string;
    };
    darkMode: {
      previewUrl: string;
      url: string;
    };
  }[];
  terminalList?: {
    client: string;
    deviceBlackList?: string[];
    deviceList: string[];
  }[];
}
/** 小部件详情list 接口数据 */
export interface ImplListRespItem {
  abilityCode: string;
  abilityVersion: number;
  added: number;
  appVersionName: string;
  code: string;
  createTime: number;
  desc: string;
  name: string;
  sort: number;
  status: number;
  statusDesc: {
    reason?: string;
    amendments?: string;
  };
  style: number;
  type: number;
  updateDesc: string;
  updateStatus: number;
  updateTime: string;
  implVersion: number;
  mark: string;
  widgetImplInfo: WidgetImplInfoProps;
  updateImplInfo: WidgetImplInfoProps;
}

/*** 运营审核失败理由 */
export interface ApprovalDetailResp {
  attachmentList: string[];
  commentList: string[];
  reasonList: string[];
}

/** 小部件版本接口信息 */
export interface AppVersionInfoItem {
  appVersionCode: number;
  appVersionName: string;
  abilityCode: string;
  abilityVersion: number;
}
